import React, { useState } from 'react';
import { Button } from '@zurich-primitives/button';
import { Modal } from '@zurich-base-ui/components.modal';
import styles from './Feedback.module.scss';
import { IFeedbackModal } from './Feedback.interface';

export const FeedbackModal: React.FC<IFeedbackModal> = ({
  isOpen,
  onClose,
  onSubmit,
  feedbackType
}) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [reason, setReason] = useState('');

  const positiveOptions = ['Easy to understand', 'Correct answer', 'Other'];
  const negativeOptions = [
    'Inaccurate',
    'Inappropriate',
    'Irrelevant',
    'Other'
  ];

  const options =
    feedbackType === 'positive' ? positiveOptions : negativeOptions;

  const handleOptionToggle = (option: string): void => {
    setSelectedOptions((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option)
        : [...prev, option]
    );
  };

  const handleSubmit = (): void => {
    onSubmit(feedbackType, selectedOptions, reason);
    handleClose(false);
  };

  const handleClose = (cancelled: boolean): void => {
    setSelectedOptions([]);
    setReason('');
    onClose(cancelled);
  };

  const isSubmitDisabled = selectedOptions.length === 0 && reason.trim() === '';

  return (
    <Modal on={isOpen} onClose={() => handleClose(true)} variant="slim">
      <div className={`${styles.modal} p-8 pt-6`}>
        <h2 className="f-data-blue highlight">Share Your Feedback</h2>

        {feedbackType === 'negative' && (
          <p>Sorry the response wasn&apos;t as you expected!</p>
        )}

        <div className={styles.wrapper}>
          {feedbackType === 'negative' && (
            <>
              <h3>What could we improve?</h3>
              <p className={styles.instruction}>
                Select all applicable options
              </p>
            </>
          )}

          <div className={styles.options}>
            {options.map((option) => (
              <button
                key={option}
                type="button"
                className={`${styles.option} ${
                  selectedOptions.includes(option) ? styles.selected : ''
                }`}
                onClick={() => handleOptionToggle(option)}
              >
                {option}
              </button>
            ))}
          </div>

          <textarea
            className={styles.textarea}
            placeholder={`Why was the response ${
              feedbackType === 'positive' ? 'useful' : 'not useful'
            }?`}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
          />
        </div>

        <div className={styles.buttons}>
          <Button variant="secondary" onClick={() => handleClose(true)}>
            <Button.Label>Cancel</Button.Label>
          </Button>

          <Button onClick={handleSubmit} disabled={isSubmitDisabled}>
            <Button.Label>Submit feedback</Button.Label>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
